import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Layout, PlotData } from 'plotly.js'

import PageHeader from '../PageHeader/PageHeader'
import { onDateChange } from '../Shared/DateRangeInput/DateRangeInput'

import AnalyticsContent from './AnalyticsContent/AnalyticsContent'
import AnalyticsDataAggregation from './AnalyticsDataAggregation/AnalyticsDataAggregation'

import styles from './analytics.module.scss'

export interface IAnalyticsData {
    data: PlotData[]
    layout: Partial<Layout>
}

function Analytics() {
    const { t } = useTranslation()
    const [aggregationType, setAggregationType] = useState('day')
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')

    const params = new URLSearchParams({
        aggregation_type: aggregationType,
    })

    if (dateFrom) {
        params.append('date_from', dateFrom)
    }
    if (dateTo) {
        params.append('date_to', dateTo)
    }

    return (
        <div className={styles.analytics}>
            <PageHeader
                title={t('analytics')}
                className={styles.analytics__header}
            >
                <AnalyticsDataAggregation
                    aggregationType={aggregationType}
                    onAggregationChange={setAggregationType}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    onDateChange={onDateChange(setDateFrom, setDateTo)}
                />
            </PageHeader>
            <main className={styles.analytics__main}>
                <AnalyticsContent params={params} />
            </main>
        </div>
    )
}

export default Analytics
